// oxlint-disable-next-line no-unused-vars
import React, { use, useMemo, type PropsWithChildren } from 'react'
import { SegmentService } from './api'
import { genericMemo } from '@/components/genericMemo'

// localStorage-backed mock today; when this moves to a real backend, construct
// the service with an apiUrl + authedFetch here (like AudienceServiceProvider)
// — consumers via useSegmentService stay unchanged.
const defaultService = new SegmentService()

export const SegmentServiceContext = React.createContext(defaultService)

export const SegmentServiceProvider: React.FC<PropsWithChildren> = genericMemo(
    ({ children }) => {
        const service = useMemo(() => new SegmentService(), [])
        return (
            <SegmentServiceContext value={service}>
                {children}
            </SegmentServiceContext>
        )
    }
)

export const useSegmentService = (): SegmentService =>
    use(SegmentServiceContext)
